const jssTheme = {
  colors: {
    primary: "rgb(221 177 115)",
    primaryHovered: "rgb(190 144 82)",
    accent: "#6a79aa",

    textPrimary: "#f7f7f7",
    textSecondary: "#d8d8d8",
    textDark: "#505050",

    light100: "#fff",
    light200: "#fbfbff",
    light300: "#f7f7f7",
    light400: "#d8d8d8",
    light500: "#c4c4c4",

    dark400: "#7e7e7e",
    dark1000: "#000",
  },
  fonts: {
    ManropeRegular: "Manrope Regular",
    ManropeBold: "Manrope Bold",
  },
};

export default jssTheme;
